import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Matilde Anaray, “la pastorcita de Socha”, es uno de esos personajes históricos que por largo tiempo pasaron
      desapercibidos: no hacía parte de la Historia Oficial (esa que se escribe en mayúscula) y su gesto generoso de
      desprendimiento fue uno de los muchos que diversos patriotas ejercieron en su momento, ya fuera por simpatía al
      ejército libertador o por obligación. Nada que pareciera especial.
    </p>
    <p className="content justified">
      Con el pasar de los años, la pequeña pastorcita del páramo ha ganado protagonismo (incluso la casa de la
      gobernación de Boyacá lleva su nombre), pero cuando Oswaldo Díaz Díaz escribió un cuento basado en ella, la
      historia de Matilde Anaray poco sonaba.
    </p>
    <p className="content justified">
      El cuento de Oswaldo Díaz Díaz nos ubica en el helado páramo de Socha, por los altos de Matarredonda. Allí,
      Matilde, una joven pastorcita, vive en la más profunda soledad: sin amigos, sin familia, acompañada solamente por
      el silencio, el sonido del viento, la neblina y sus ovejas.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      “Pero una niña de catorce años, por solitaria que viva, no puede pasar sin sueños y sin deseos. Y Matilde Anaray
      tenía un deseo que la hacía soñar mucho […] Una falda de frisa, una ruana de buen abrigo y poder lucir las dos en
      la misa mayor de Socha”.
    </p>
    <p className="content justified">
      La niña ahorró su escaso jornal semanal y al fin, tras varios meses de privaciones, pudo obtener la falda y la
      ruana olorosas a vellón y a romero.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Dos versiones, una pastorcita, un acto heroico</h3>
      <p className="content justified">
        Contrario a la patriota historia que se cuenta por estos días en la que la niña (a veces de once años, en otros
        relatos de trece) lidera a un grupo de patriotas para que se desprendan de sus ropas y se las entreguen al
        ejército libertador que cruza el páramo, en la versión de Don Os hay más sacrificio, soledad y desprendimiento.
      </p>
      <p className="content justified">
        Las campanas de la iglesia llaman a los campesinos y los fuegos artificiales los invitan a un gran evento. Todos
        eligen sus atuendos más lujosos y, una vez en la iglesia, el cura don Juan Tomás Romero manda a cerrar las
        puertas. Un elocuente sermón invita a lo que de todas maneras deben hacer por presión militar: quitarse sus
        ropas y entregarlas.
      </p>
      <p className="content justified">
        “La elocuencia del padre Romero y el egoísmo batallaban en el alma de la pastora de Matarredonda”, escribe el
        autor y con este gesto nos muestra a una niña real, no una heroína de propaganda. Una simple chica de 14 años
        que debe entregar aquello con lo que tanto soñó. Pero no solo eso, sino aquello que es su única posibilidad de
        abrigo ante el impetuoso clima del páramo.
      </p>
      <p className="content justified">
        Quién mejor que ella para entender el frío del páramo. Quién mejor que ella para entender el deseo de estar
        abrigada.
      </p>
      <p className="content justified">
        Sin embargo, la niña no tiene alternativa. Entrega sus ropas y la historia, que podría concluir en este gesto de
        sacrificio, concluye, más bien, con un cierre a lo Hans Christian Andersen, en el que el valor de las cosas en
        la vida está más allá de los objetos:
      </p>
      <p className="content justified">
        “Matilde Anaray tiritaba de frío en las largas horas de su aislamiento, pero en su corazón ardía una hoguera que
        la reconfortaba toda y que le daba calor y alegría: la llamita de su sacrificio, el fuego de su patriotismo que
        palpitaba y se batía como el tremolar de una bandera vista entre la niebla”.
      </p>
    </div>
  </div>
);
